<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  height: 100%;
  min-height: 100vh;
}

#wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.text-center {
  text-align: center;
}

</style>
